import BaseEntity from './base/BaseEntity.model';

export default class Documento extends BaseEntity{
    public tipoDocumentoId?: number;
    public refEntityName?: string;
    public refEntityKey?: string;
    public refEntityValue?: string;
    constructor(public fileName?: string, public contentType?: string, public nombreOriginal?: string){
        super();
    }
}